import React from "react";

import user_list_cols from "./user_list_cols.png";

const ViewingUsers = () => (
  <div id="admin_email_user" className="section">
    <h2>3.2 List Users</h2>
    <p>
      Here you can view
      <ul>
        <li>The names of users that have been added to the site</li>
        <li>
          Additional information can be viewed by selecting columns in the tool bar (see below for
          details)
        </li>
        <ul>
          <li>When they were added</li>
          <li>When they first accessed the site</li>
          <li>When they last accessed the site</li>
          <li>The number of times they have accessed the site</li>
        </ul>
      </ul>
    </p>
    <p>
      Clicking on the <strong>Columns</strong> button will show a list of available columns, which
      can be toggled.
    </p>
    <img src={user_list_cols} alt="Create user email options" className="center" />
    <p>
      If there are many users on the portal, the results will be split over multiple pages. By
      default, 20 users are shown. This be changed via with the Show 20 entries button on the
      top-left.
    </p>
  </div>
);

export default ViewingUsers;
